module.exports = __webpack_public_path__ + "img/win.efe2a21c.webp";